import dompurify from 'dompurify'

// Use these before passing text or HTML from the API, CRM or search index to v-html or innerHTML.

export const escapeHtml = (value: string) =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')

// Basic formatting only: no scripts, event handlers, styles, iframes or images.
const basicHtmlConfig = {
  ALLOWED_TAGS: ['a', 'b', 'br', 'em', 'i', 'li', 'ol', 'p', 'strong', 'u', 'ul'],
  ALLOWED_ATTR: ['class', 'href', 'rel', 'target'],
}

export const sanitizeBasicHtml = (html: string | null | undefined) =>
  html ? dompurify.sanitize(html, basicHtmlConfig) : ''

// Rich markup (headings, tables, images) for intro texts and documents; DOMPurify's
// defaults still strip scripts, event handlers and javascript: URLs.
const richHtmlConfig = {
  ADD_ATTR: ['target'],
}

export const sanitizeRichHtml = (html: string | null | undefined) =>
  html ? dompurify.sanitize(html, richHtmlConfig) : ''
